import { render, staticRenderFns } from "./CardWelcome.vue?vue&type=template&id=5ea3c7b5"
import script from "./CardWelcome.vue?vue&type=script&lang=js"
export * from "./CardWelcome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports